/** Opening the right screen from a notification or a link. A notification carries an address like /?tab=invoices&focus=portal-invoice-123 (families) or /?go=incidents/incidents (staff): which page, and optionally which item to scroll to and highlight. */

const KEYS = ["tab", "focus", "go"];

export function parseOpen(url) {
  try {
    const q = new URL(url, window.location.origin).searchParams;
    return { tab: q.get("tab") || "", focus: q.get("focus") || "", go: q.get("go") || "" };
  } catch { return { tab: "", focus: "", go: "" }; }
}

/** What the address the app was opened with asks for (a tap on a notification while the app was closed). The request is taken off the address so a reload doesn't repeat it. */
export function takeFromLocation() {
  const o = parseOpen(window.location.href);
  if (o.tab || o.focus || o.go) {
    try {
      const q = new URLSearchParams(window.location.search);
      KEYS.forEach((k) => q.delete(k));
      window.history.replaceState(null, "", window.location.pathname + (q.toString() ? `?${q}` : "") + window.location.hash);
    } catch { /* leave the address as it is */ }
  }
  return o;
}

/** Scrolls to an item and rings it for a few seconds. Waits a moment for the page to draw it. */
export function focusElement(id, tries = 40) {
  if (!id) return;
  const look = (left) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("hp-flash");
      setTimeout(() => el.classList.remove("hp-flash"), 3500);
    } else if (left > 0) setTimeout(() => look(left - 1), 150);
  };
  look(tries);
}

/** The service worker tells an already-open app which address a tapped notification wants; this turns that into one event the pages listen for. */
export function listenForOpen() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.addEventListener("message", (e) => {
    if (e.data && e.data.type === "hp-open" && typeof e.data.url === "string") window.dispatchEvent(new CustomEvent("hp-open", { detail: e.data.url }));
    if (e.data && e.data.type === "hp-push") window.dispatchEvent(new CustomEvent("hp-push", { detail: e.data.category || "" }));      // a notification just arrived: pages refresh their counts
  });
}
